'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (_ref) {
  var pathname = _ref.pathname,
      search = _ref.search;

  if (search) {
    if (search.indexOf('?') !== 0) {
      search = '?' + search;
    }

    return '' + pathname + search;
  }

  return pathname;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-first-router/dist/pure-utils/pathnamePlusSearch.js
// module id = 242
// module chunks = 0